<div *ngIf="loadingSpinnerService.loader() | async">
  <mat-progress-spinner
    color="primary"
    data-test="progress-spinner"
    mode="indeterminate">
  </mat-progress-spinner>
</div>
